<template>
	<div
		class="ks-videoeditor-track ks-videoeditor-track-overlay"
		:data-id="track.id"
		data-kind="overlay"
		:style="track_style"
		@mousedown.prevent="$emit('scrub-down', $event)"
		@click="$emit('background-click')">
		<div
			v-for="item in track.items"
			:key="item.overlay.id"
			class="ks-videoeditor-clip ks-videoeditor-overlay has-poster"
			:class="{selected: item.overlay.id == selected_id, fade: in_transition(item.overlay).type == 'fade', 'fade-out': out_transition(item.overlay).type == 'fade'}"
			:style="block_style(item.overlay.start, item.overlay.duration, item.lane, 'overlay', item.overlay.id)"
			@mousedown.stop.prevent="$emit('item-down', item.overlay, 'move', $event)"
			@click.stop>
			<div class="ks-videoeditor-handle left" @mousedown.stop.prevent="$emit('item-down', item.overlay, 'start', $event)"></div>
			<img class="ks-videoeditor-clip-poster" :src="item.overlay.url" draggable="false" alt="">
			<div class="ks-videoeditor-clip-text">
				<div class="ks-videoeditor-clip-title">{{ item.overlay.title }}</div>
				<div class="ks-videoeditor-clip-time">{{ fmt(item.overlay.duration) }}<span v-if="in_transition(item.overlay).type == 'fade'"> &middot; fade in</span><span v-if="out_transition(item.overlay).type == 'fade'"> &middot; fade out</span></div>
			</div>
			<div class="ks-videoeditor-handle right" @mousedown.stop.prevent="$emit('item-down', item.overlay, 'end', $event)"></div>
		</div>
	</div>
</template>

<script>
import track_mixin from './track_mixin.js'
import {fmt, in_transition, out_transition} from './utils.js'

// Track of image overlays
export default {
	mixins: [track_mixin],
	props: {
		selected_id: Number
	},
	methods: {
		fmt,
		in_transition,
		out_transition
	}
}
</script>
